module.exports = __webpack_public_path__ + "a2b787638b9fd92e148b2f01ec1d037e.svg";